
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TherapeuticCards, TherapeuticCardsService } from './contract.service';
import { UserSessionService, PatientParms, getNgBsObj, getDateObj } from '../../shared';
import { StepperComponent } from '../../blocks';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CoverageClass } from '../../hospitalSetup/fhir-test/fhir-test.service';


@Component({
    selector: 'sanabel-therapeuticCards',
    templateUrl: './Contract-list.component.html',
    providers: [TherapeuticCardsService]

})
export class ContractListComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    therapeuticCard: TherapeuticCards[] = [];
    nphiesCoverageClass: CoverageClass[] = [];
    patientParms: PatientParms = <PatientParms>{};
    myStepNumber: number = 209;
    code: number;
    @Input() stepperComponent: StepperComponent;
    constructor(
        private _therapeuticCardsService: TherapeuticCardsService,
        public translate: TranslateService,
        private _userSessionService: UserSessionService
    ) { }

    gettherapeuticCardsList(PatientCode) {

        if (PatientCode > 0) {
            this.nphiesCoverageClass = [];
            this._therapeuticCardsService.getTherapeuticCards(PatientCode)
                .subscribe(
                    res => {
                        this.therapeuticCard = res.data;
                        //------------Added by basma 
                        if (res.data1 && res.data1.length > 0) {

                            this.nphiesCoverageClass = res.data1;
                        }
                        //-------------------------------
                    },
                    error => console.log("unable to load therapeuticCards"),
                    () => {
                    });
        } else {
            this.therapeuticCard = [];
            this.nphiesCoverageClass = [];
        }
    }
    ngOnInit() {
        this.nphiesCoverageClass = [];
        this._userSessionService.getSessionKey$('patientForEdit')
            .subscribe((keys: any) => {
                if (keys && keys.name == 'patientForEdit' && keys.value["code"]) {
                    this.patientParms.patCode = keys.value["code"];
                }
            });
        this.myStepper$();
        let _patientForEdit = this._userSessionService.getSessionKey('patientForEdit');
        if (_patientForEdit && _patientForEdit["code"]) {
            this.code = _patientForEdit["code"]
            this.gettherapeuticCardsList(_patientForEdit["code"]);
        }

    } ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    //-----observable on step on wizard
    myStepper$() {
        if (this.stepperComponent) {
            this.stepperComponent.getCurrentStep().pipe(
                takeUntil(this.ngUnsubscribe))
                .subscribe((step: any) => {
                    if (step && step.serial == this.myStepNumber) {
                        this.gettherapeuticCardsList(this.patientParms.patCode);
                    }

                })
        }
    }

    updatestatus: number
    onRowIconClick(actionCode: number, row: any) {

        if (actionCode == 403) {
            this.delete(row);
        }
        if (actionCode == 402) {
            row.updatestatus = 2
            row.endDate = row.endDate ? getNgBsObj(row.endDate) : null
        }
    }
    disableFlag: number = 0;
    onCoverageClassRowIconClick(actionCode: number, row: any) {
        if (actionCode == 403) {
            row.dataStatus = 3
            this.deleteCoverageClass(row);
        }
        if (actionCode == 402) {
            row.dataStatus = 2
            this.disableFlag = 1;
        }
    }

    onCoverageClassTypeClick(ev, row) {
        if (ev && ev.code) {
            row.coverageClassType = ev.codeAsStringEn
            row.coverageClassTypeCode = ev.code
        }
    }

    undoEdit(item: any) {
        item.updatestatus = 1
    }

    undoCoverageClassEdit(row) {
        row.dataStatus = null;
    }

    UpdateEdit(row) {
        row.endDate = getDateObj(row.endDate)
        console.log('****ROw', row)
        this._therapeuticCardsService.UpdateTherapeuticCards(row)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(msg => {
                // if (msg && msg.returnFlag) {
                this.gettherapeuticCardsList(this.patientParms.patCode ? this.patientParms.patCode : this.therapeuticCard[0].patientCode);
                //}
            },
                err => console.log(err),
                () => {
                    row.updatestatus = 1
                });

    }
    deleteCoverageClass(row) {
        let arr = []
        row['dataStatus'] = 3
        arr.push(row)
        this._therapeuticCardsService.NphiesCoverageClassSave(arr)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(msg => {
                this.gettherapeuticCardsList(row.patCode);
            })
    }

    updateCoverageClass(row) {
        let arr = []
        row['dataStatus'] = 2
        arr.push(row)
        this._therapeuticCardsService.NphiesCoverageClassSave(arr)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(msg => {
                this.gettherapeuticCardsList(row.patCode);
            }
                ,
                error => console.log(error),
                () => {
                    this.disableFlag = 0;
                }
            )
    }
    delete(row: any) {

        this._therapeuticCardsService.deleteTherapeuticCards(row)
            .subscribe(c => {
                /// this.gettherapeuticCardsList(this.patientParms.patCode);   ///COMMENTED BY --ENG.ASMAA --25-12-23-- EL-NAEEM
                this.gettherapeuticCardsList(row.patientCode);
            })


    }
    contractClicked(ev: any, row: TherapeuticCards) {
        if (!ev.AutoEmited) {
            row.contractId = ev.code;
            row.startDate = ev.startDate;
            row.endDate = ev.endDate;
            row.policyNumber = ev.policyNumber
            row.cardNo = ev.cardNo ? ev.cardNo : row.cardNo;  /// ENG.ASMAA ---25/12/2023
        }
    }

    addNewPrivilege() {
        let _patientForEdit = this._userSessionService.getSessionKey('patientForEdit');
        this.therapeuticCard.unshift(<TherapeuticCards>{
            code: this.therapeuticCard.length * -1,
            dataStatus: 1,
            patientCode: this.patientParms.patCode ? this.patientParms.patCode : _patientForEdit["code"]
        });
    }

    addNewCoverageClass() {
        let _patientForEdit = this._userSessionService.getSessionKey('patientForEdit');

        this.nphiesCoverageClass.unshift(<CoverageClass>{
            serial: (this.therapeuticCard.length + 1) * -1,
            coverageClassType: null,
            coverageClassvalue: null,
            coverageClassName: null,
            memberID: null,
            policyNo: null,
            policyName: null,
            coverageNetwork: null,
            identityValue: _patientForEdit['identityValue'],
            patCode: _patientForEdit['code'],
            dataStatus: 1
        });
    }
    save() {
        console.log(this.therapeuticCard);
        this.therapeuticCard.forEach(
            el => {
                el.startDate = getDateObj(el.startDate);
                el.endDate = getDateObj(el.endDate);
            }
        )
        this._therapeuticCardsService.addTherapeuticCards(this.therapeuticCard)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(msg => {
                // if (msg && msg.returnFlag) {
                this.gettherapeuticCardsList(this.patientParms.patCode ? this.patientParms.patCode : this.therapeuticCard[0].patientCode);
                //}
            })
    }

    saveCoverageClass() {
        this._therapeuticCardsService.NphiesCoverageClassSave(this.nphiesCoverageClass)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(msg => {
                // if (msg && msg.returnFlag) {
                this.gettherapeuticCardsList(this.nphiesCoverageClass[0].patCode);
                //}
            })
    }

    paginate(event) { }
}
